import { practitionerHttpService } from "../store/practitioner-http-service";

let csrfPromise: Promise<void> | null = null;

export function initCsrf(): Promise<void> {
  if (!csrfPromise) {
    csrfPromise = practitionerHttpService
      .get("/sanctum/csrf-cookie")
      .then(() => {})
      .catch((error) => {
        csrfPromise = null;
        return Promise.reject(error);
      });
  }
  return csrfPromise;
}

export function resetCsrf(): void {
  csrfPromise = null;
}
